import { $FixMe } from '@eventbrite/ts-utils';
import React from 'react';
import { EnvProvider } from '../../context/env';

//TODO: Move more of the base level contexts into this provider. Location / Router / etc
export const DiscoverProviders: React.FunctionComponent = (props: $FixMe) => {
    return (
        <EnvProvider
            env={props.env}
            request={props.request}
            user={props.user}
            app_version={props.app_version}
            app_name={props.app_name}
            isBotRequest={props.isBotRequest}
        >
            {props.children}
        </EnvProvider>
    );
};
